import { makeAutoObservable } from "mobx";
import { PromotionStorageManager } from "../storageManagers";
export class PCheckout {
    constructor(params) {
        this.purchaseOrder = params.purchaseOrder;
        this.restaurant = params.restaurant;
        this.locale = params.locale;
        this.checkoutService = params.checkoutService;
        this.orderDetails = params.orderDetails;
        this.storageManager = params.storageManager;
        this.fulfillmentFormControler = params.fulfillmentFormControler;
        this.paymentFormControler = params.paymentFormControler;
        this.contactFormControler = params.contactFormControler;
        this.consentsFormControler = params.consentsFormControler;
        this.invoiceFormControler = params.invoiceFormControler;
        this.placeOrderCallback = params.placeOrderCallback;
        this.touched = false;
        this._serverErrors = [];
        this.storageManager.restore();
        makeAutoObservable(this);
    }
    touch() {
        this.touched = true;
        this.fulfillmentFormControler.touch();
        this.paymentFormControler.touch();
        this.contactFormControler.touch();
        this.invoiceFormControler.touch();
        this.consentsFormControler.touch();
    }
    // TODO: get more detailed front-end errors
    get formInvalid() {
        return this.touched && !this.purchaseOrder.isCheckoutFormValid;
    }
    get enableMarketingConsents() {
        return this.restaurant.enableMarketingConsents;
    }
    // TODO: if in the cart is promotion that has marketing consent required and marketing consent is not checked, this should return true
    get hasMarketingConsentError() {
        return false;
    }
    get price() {
        return this.purchaseOrder.price;
    }
    get alternativePrice() {
        return this.purchaseOrder.alternativePrice;
    }
    get serverErrors() {
        return this._serverErrors;
    }
    get error() {
        return this.purchaseOrder.error;
    }
    get fulfillmentMethods() {
        return this.purchaseOrder.fulfillmentMethods;
    }
    get orderLines() {
        return this.purchaseOrder.orderLines;
    }
    get paymentMediums() {
        var _a;
        return ((_a = this.restaurant.paymentMediums) === null || _a === void 0 ? void 0 : _a.raw) || [];
    }
    get selectedPaymentMedium() {
        const domain = this.purchaseOrder.paymentMedium;
        if (domain === null) {
            return null;
        }
        const medium = this.paymentMediums.find((medium) => medium.isSelected(domain)) || null;
        if (medium === null) {
            return null;
        }
        return medium.kind === "OnlineGroup" ? medium.getChannel(domain) : medium;
    }
    get isOnlinePayment() {
        return (this.selectedPaymentMedium !== null &&
            this.selectedPaymentMedium.kind === "SingleChannel");
    }
    get contactDetailsLocked() {
        return this.purchaseOrder.contactDetailsLocked;
    }
    get restaurantFranchiseName() {
        return this.restaurant.franchiseName;
    }
    get restaurantOpeningHour() {
        return this.restaurant.openingHour;
    }
    get promotionInstances() {
        return this.orderDetails.promotionScheme.promotionInstances;
    }
    // TODO: if promotion that requires marketing consent is in the cart, user should be able to remove it without accepting marketing consent
    removeMarketingPromotion() {
        console.log("TODO: remove marketing promotion");
    }
    // TODO: if user has First Order Discount coupon active he has locked contact details (phone & email), user should be able to unlock this by removing FOD coupon
    removeFODCoupon() {
        console.log("TODO: remove FOD coupon");
    }
    get isPaymentMediumRestored() {
        return this.purchaseOrder.isPaymentMediumRestored;
    }
    get canPlaceOrder() {
        return this.purchaseOrder.canPlaceOrder;
    }
    // Used only to show debug info
    get availability() {
        return this.purchaseOrder.availability;
    }
    async placeOrder(appOriginPath) {
        if (!this.canPlaceOrder) {
            return;
        }
        const req = this.purchaseOrder.checkoutData({
            appOrigin: appOriginPath,
            locale: this.locale,
        });
        const res = await this.checkoutService.checkout(req);
        if (res.tag === "Errors") {
            this._serverErrors = res.contents;
        }
        this.storageManager.store();
        PromotionStorageManager.erase();
        this.placeOrderCallback(res);
    }
}
